import * as Yup from "yup";

import { validaDDD } from "../../../../utils/validations";

export const CELULAR_TYPE = "CELULAR";

export const phoneTypes = [
  CELULAR_TYPE,
  "RESIDENCIAL",
  "COMERCIAL",
  "REFERENCIA",
  "OUTRO",
] as const;

export const getPhoneValues = (phone: string) => {
  const fullTel = phone.replace(/[()\s-]/g, "");
  const area = fullTel.slice(0, 2);
  const tel = fullTel.slice(2);

  return {
    area,
    tel,
  };
};

export const addNewPhoneSchema = Yup.object({
  type: Yup.string()
    .min(1, "Selecione um tipo de telefone.")
    .oneOf(
      phoneTypes as unknown as string[],
      "Selecione um tipo válido de telefone."
    ),
  phone: Yup.string()
    .required("Preencha o número.")
    .test(
      "minLength",
      "O Número deve possuir no mínimo 8 dígitos.",
      (phone) => {
        if (phone) {
          const { tel } = getPhoneValues(phone);

          return tel.length >= 8;
        }
        return true;
      }
    )
    .test(
      "maxLength",
      "O Número deve possuir no máximo 10 dígitos.",
      (phone) => {
        if (phone) {
          const { tel } = getPhoneValues(phone);

          return tel.length <= 10;
        }
        return true;
      }
    )
    .test("validArea", "O DDD do telefone é inválido.", (phone) => {
      if (phone) {
        const { area } = getPhoneValues(phone);

        const isValidArea = validaDDD(area);

        return isValidArea;
      }
      return true;
    }),
  utilizadoTaxaBonificada: Yup.boolean(),
  utilizadoServicoSms: Yup.boolean(),
  isRecebeFaturaSms: Yup.boolean(),
}).test("phoneValidFirstLetter", (values, ctx) => {
  const fullTel = values?.phone?.replace(/[()\s-]/g, "") ?? "";
  const tel = fullTel.substr(2);
  const firstDigit = tel.at(0);

  const isValidPhoneTel = firstDigit
    ? ["9", "8", "7", "6"].includes(firstDigit)
    : true;

  if (values.type === CELULAR_TYPE && !isValidPhoneTel) {
    return ctx.createError({
      path: "phone",
      message: "Celulares devem começar com o dígito 9, 8, 7 ou 6.",
    });
  }

  return true;
});
